import { createContext } from 'react';
import { ToastInitialValue } from '../../type';

export const initialToastValue: ToastInitialValue = {
  showToast: () => {},
};

export const ToastContext = createContext(initialToastValue);
